import WithPropertyRole from '@/components/WithPropertyRole';
import SettingsProperty from '@/components/settings/pages/SettingsProperty';
import { CurrentHouseProvider } from '@/context/CurrentHouseContext';
import { Permission } from '@/utils/permissionUtils';

/**
 * Property settings page scoped to a specific property via its public ID in the URL.
 */
export const Route = createFileRoute({
	component: () => (
		<CurrentHouseProvider>
			<WithPropertyRole requiredPermissions={[Permission.HOUSE_ADMIN]}>
				<SettingsProperty />
			</WithPropertyRole>
		</CurrentHouseProvider>
	),
});
